export const RolesTableColumns = [
    { id: "name",              labelEn: "Name",        labelAr: "الاسم",           align: "left",   sortable: true },
    { id: "label",             labelEn: "Label",       labelAr: "العنوان",         align: "left",   sortable: false },
    { id: "permissions_count", labelEn: "Permissions", labelAr: "الصلاحيات",       align: "center", sortable: false },
    { id: "users_count",       labelEn: "Users",       labelAr: "المستخدمون",      align: "center", sortable: false },
    { id: "guard_name",        labelEn: "Guard",       labelAr: "نوع الحراسة",     align: "center", sortable: false },
];
